(() => {
  const init = () => document.querySelectorAll('.bec-announcement[data-bec-announcement]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const messages = [...root.querySelectorAll('[data-announcement-message]')];
    const toggle = root.querySelector('[data-announcement-toggle]');
    const icon = root.querySelector('[data-announcement-icon]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches, timer, index = 0, closed = false;
    const stop = () => { clearInterval(timer); timer = undefined; };
    const update = () => {
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      icon.textContent = paused ? '▷' : 'Ⅱ';
    };
    const start = () => {
      stop();
      if (paused || closed || document.hidden || messages.length < 2) return;
      timer = setInterval(() => {
        if (!root.isConnected) { stop(); return; }
        if (root.matches(':hover') || root.querySelector('[data-announcement-message]:focus')) return;
        index = (index + 1) % messages.length;
        messages.forEach((message, i) => { message.hidden = i !== index; });
      }, Number(root.dataset.speed) || 7000);
    };
    toggle.addEventListener('click', () => { paused = !paused; update(); start(); });
    root.querySelector('[data-announcement-close]').addEventListener('click', () => {
      closed = true; root.hidden = true; stop();
      document.querySelector('header a')?.focus();
    });
    document.addEventListener('visibilitychange', start);
    motion.addEventListener('change', () => { if (motion.matches) { paused = true; update(); stop(); } });
    update(); start();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
